<script lang="ts">
  import { fade } from 'svelte/transition';

  import Logo from '@/ui/base/Logo.svelte';

  const { customerLogo }: { customerLogo?: string } = $props();
</script>

<div class="flex w-full items-center justify-center p-2.5">
  <div
    class={[
      customerLogo ? 'w-full' : 'w-auto',
      'flex items-center justify-center overflow-visible transition-all duration-1000 ease-in-out',
    ]}
    style="interpolate-size: allow-keywords"
  >
    <Logo scale={40 / 48} aria-label="TEO" />

    {#if customerLogo}
      <img
        src={customerLogo}
        in:fade={{ duration: 1000 }}
        alt=""
        class="ml-auto max-h-10 max-w-24"
      />
    {/if}
  </div>
</div>
